import React from 'react';
import axios from 'axios';
import 'antd/dist/antd.css';
import { Input, Layout } from 'antd';
import { List, Avatar, Icon,Row,Col } from 'antd';
//import Header from './Tabs';
import SelectCountry from './News';
import Login from './profile';
import SelectSource from './Source';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import SelectCategory from './example';
import * as firebase from "firebase/app";
import "firebase/auth";

//import SelectCategory from './example';


const Search = Input.Search;
var firebaseConfig = {
  apiKey: "AIzaSyAjdhhG7r6qShHR2AcuLFgMlGPHBcctLYw",
  authDomain: "newshunt-9a0ed.firebaseapp.com",
  databaseURL: "https://newshunt-9a0ed.firebaseio.com",
  projectId: "newshunt-9a0ed",
  storageBucket: "",
  messagingSenderId: "1084666652732",
  appId: "1:1084666652732:web:e47a546bec61a54b"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);



const IconText = ({ type, text }) => (
    <span>
      <Icon type={type} style={{ marginRight: 8 }} />
      {text}
    </span>
  );

class App extends React.Component{
constructor(props){
  super(props)
  this.state={
  
  }
}

  

componentDidMount(){
    this.getNews();
}

getNews(){
    
    var url = 'https://newsapi.org/v2/top-headlines?' +'country=in&' +'apiKey=3c441607425442deb9266c094691a026';

    axios.get(url)
    .then((res)=>{
       console.log(res.data.articles)
     this.setState({
         articles : res.data.articles
     })
    })

}


searchNews(search){
    var url = 'https://newsapi.org/v2/top-headlines?' +
    'country=in&' +
    'apiKey=3c441607425442deb9266c094691a026';

    axios.get(url+"&q="+search)
    .then((res)=>{
       console.log(res.data.articles)
     this.setState({
         articles : res.data.articles
     })
    })
}
Change = (value)=>{
  console.log(`selected ${value}`);
  this.setState(
    {country:value}
  )
  
   var url = 'https://newsapi.org/v2/top-headlines?' +`country=${value}&` +'apiKey=3c441607425442deb9266c094691a026';

    axios.get(url)
    .then((res)=>{
        console.log(res.data);
        this.setState({
          articles : res.data.articles
        })
    })
  }

Esource= (event)=>{
  console.log(`selected ${event}`);
  var url = 'https://newsapi.org/v2/top-headlines?' +`sources=${event}&` +'apiKey=3c441607425442deb9266c094691a026';

    axios.get(url)
    .then((res)=>{
        console.log(res.data);
        this.setState({
          articles : res.data.articles
        })
    })
  }
  Category = (value) => {
    //let x = this.state;

    console.log(`selected ${value}`);
    this.setState(
      {category:value}
    ) 
    
      
       var url = `https://newsapi.org/v2/top-headlines?country=${this.state.country}&category=${value}&`+ 'apiKey=3c441607425442deb9266c094691a026';
    
         axios.get(url)
         .then((res)=>{
             console.log(res.data);
             
             this.setState({
               articles : res.data.articles
 
    })
  })
}
googleLogin(){
  var provider = new firebase.auth.GoogleAuthProvider();


  firebase.auth().signInWithPopup(provider).then(function(result) {
    // This gives you a Google Access Token. You can use it to access the Google API.
    var token = result.credential.accessToken;
    // The signed-in user info.
    var user = result.user;
    console.log(user.displayName,user.email);
    // ...
  }).catch(function(error) {
    // Handle Errors here.
    var errorCode = error.code;
    var errorMessage = error.message;
    // The email of the user's account used.
    var email = error.email;
    // The firebase.auth.AuthCredential type that was used.
    var credential = error.credential;
    // ...
  });
}

render(){
  
    return ( 
       
          <div>
          <div >
            <h1  style={{width: 350,marginLeft: 540}}>NewsHunt</h1>
           
            
          </div>
          <Search placeholder="Search"  style={{ width: 250,marginInline:250 ,marginLeft:100}} onSearch={value => this.searchNews(value)} enterButton> 
            </Search>
            <div> 
            
            <SelectSource  Esource={this.Esource}></SelectSource>
            <Row type="flex" justify="align-full">
                <Col offset={20}>
                <SelectCategory  style={{width: 550,marginRight: 800 }}Category={this.Category}></SelectCategory>
            </Col>
            </Row>
            <Row gutter={16}>
            <Col className="gutter-row" span={8}>
            <SelectCountry Change={this.Change} ></SelectCountry>
            </Col>
            </Row>
           
            </div>
         <List
    itemLayout="vertical"
    size="medium"
    pagination={{
      onChange: page => {
        console.log(page);
      },
      pageSize:4 ,
    }}
    dataSource={this.state.articles}
    footer={
      <div>
        <b>Next Page</b> 
      </div>
    }
    renderItem={item => (
      
      <List.Item
        key={item.title}
        actions={[
                <IconText type="star-o" text="345"/>,
                <IconText type="like-o" text ="40"/>,
                <IconText type="message" text="2" />,
        ]}
        extra={
          <img
            width={272}
            alt="logo"
            src={item.urlToImage}
          />
        }
      >
        <List.Item.Meta
           avatar={<Avatar src={item.avatar} />}
          title={<a href={item.url}>{item.title}</a>}
          description={item.description}
        />
        {item.content}
      </List.Item>
    )}
    
  />
       <Login style={{marginRight:1000}}googleLogin={ this.googleLogin}></Login>
       
        </div> 
        
       
        
    )
    
}    


}

export default App; 